import { app } from '../../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.saaspass-connect.manage', {
        url: '/saaspassConnect/:connectId/manage',
        redirectTo: 'company.saaspass-connect.manage.overview',
        views: {
            '@company': 'companySaaspassConnectManage',
        },
        resolve: {
            $breadcrumbs,
            connectApplication,
            connectId,
        },
    });
}

/** @ngInject */
function $breadcrumbs(connectApplication) {
    return [{title: connectApplication.displayName}];
}

/** @ngInject */
function connectApplication(companyId, connectId, SaaspassConnectOverviewService) {
    return SaaspassConnectOverviewService.saaspassConnect.get({companyId, connectId}).$promise;
}

/** @ngInject */
function connectId($stateParams) {
    return $stateParams.connectId;
}



// WEBPACK FOOTER //
// ./src/portal/states/company/saaspass-connect/manage/manage.state.js